import { Link, useLocation } from "react-router-dom";
import { noAddressSvg } from "../../../assets/imageImport";
import { PAGES } from "../../../routeConfig";
import { normalizePath } from "../../../Layout/Common/common";

export const NoAddressBook = ({ handleAddNewClick }) => {
  const location = useLocation();
  return (
    <div className="wallet-nosaved-Card p-5 mt-4">
      <div className="row">
        <div className="col-lg-6 offset-3 text-center mx-auto">
          <img src={noAddressSvg} alt="No Saved Address" />
          <h2 className="fw-semibold mt-3">No Saved Address</h2>
          <p className="fw-light col-fs-13">
            You don't seem to have saved any address. Click on the button to add the first one
          </p>
          {normalizePath(location.pathname).includes("checkout") ? (
            <div className="product-button button-effect">
              <button onClick={handleAddNewClick} className="btn btn-products btn-addcart">
                <i className="fa-solid fa-plus" /> Add New Address
              </button>
            </div>
          ) : (
            <div className="button-effect">
              <Link to={PAGES.MYADDRESSBOOK + "/add"} className="btn btn-products theme-primary mx-auto">
                <i className="fa-solid fa-plus" /> Add New Address
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
